// SLF Main JS
document.addEventListener('DOMContentLoaded', function () {
  // Add to cart buttons (basic UX feedback)
  document.querySelectorAll('.btn-add-cart, .btn-primary[data-action="cart"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const orig = btn.textContent;
      btn.textContent = 'ADDED ✓';
      setTimeout(function () { btn.textContent = orig; }, 1800);
    });
  });

  // Email form
  const emailForm = document.querySelector('.email-form');
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = emailForm.querySelector('.email-input');
      if (input && input.value) {
        emailForm.innerHTML = '<p style="color:#C9956A;font-family:\'Jost\',sans-serif;letter-spacing:0.15em;font-size:14px;">✦ You\'re on the list — welcome to the SLF Circle.</p>';
      }
    });
  }
});
